/**
 * Página genérica usada pelo roteador para qualquer item de navegação
 * cujo módulo ainda não tem tela real construída (`core/app-shell/navegacao.ts`
 * lista todos os módulos do produto desde já; a maioria ainda não tem
 * backend nem frontend — Sprint 4 em diante, `ROADMAP.md`). Existe para
 * que clicar em qualquer item do menu sempre leve a um estado honesto,
 * nunca a uma tela quebrada ou a dado inventado.
 */
export function criarPaginaModuloIndisponivel(nomeModulo: string): HTMLElement {
  const container = document.createElement('div');
  container.innerHTML = `
    <pg-card>
      <pg-empty-state
        variant="indisponivel"
        titulo="${escaparHtml(nomeModulo)}"
        descricao="Este módulo ainda não foi implementado nesta sprint."
      ></pg-empty-state>
    </pg-card>
  `;
  return container;
}

function escaparHtml(valor: string): string {
  const div = document.createElement('div');
  div.textContent = valor;
  return div.innerHTML;
}
